import {MENUS} from "../menu";

export const ROUTER_NAMES = {
    EVENTO: 'Eventos'
}

export default [
    {
        name: ROUTER_NAMES.EVENTO,
        path: '/evento',
        meta: {
            menu: MENUS.SISTEMA,
            searchAlias: 'Evento',
            searchDescription: 'Veja todas os Eventos cadastrados',
            searchTerms: ['eventos','evento'],
            hasRole: 'role/evento'
        },
        component: () => import('@/views/Evento')
    },
]